// AUTOGENERADO: No editar manualmente.
// Ejecuta 'npm run sync-perms' para actualizar este archivo desde la base de datos (auth.modulos y auth.acciones).

import { expandTree } from "../utils/permissions";

const PERMISSIONS_TREE = {
  "inicio": {
    "datos_paciente": {
      "telefono": [
        "crear_telefono",
        "eliminar_telefono",
        "ver_telefono"
      ],
      "correo": [
        "crear_correo",
        "eliminar_correo",
        "ver_correo"
      ],
      "direccion": [
        "crear_direccion",
        "eliminar_direccion",
        "ver_direccion"
      ]
    },
    "datos_generales": [
      "ver_graficas",
      "cargar_resultado",
      "preguntas",
      "importar_pc_sios"
    ]
  },
  "paciente": {
    "exportar_caso": [
      "exportar_pdf",
      "exportar_csv"
    ],
    "cerrarsesion": [],
    "buscar_paciente": [],
    "asignar_grupo": []
  },
  "configuracion": {
    "cargar_datos_masivos": [
      "cronico",
      "gestante",
      "laboratorio",
      "resultados",
      "cargue_paciente_masivo"
    ],
    "maestros": {
      "parametrizacion": [
        "ruta",
        "grupo",
        "subgrupo",
        "consecutivo",
        "rutaspym",
        "preguntariesgo",
        "preguntasexcluidassubgrupo",
        "actividadesexcluidassubgrupo"
      ],
      "administrador": [
        "usuarios",
        "permisos",
        "calculadoras_dinamicas"
      ]
    },
    "tamanoletra": [],
    "ver_logs_sincronizador": []
  },
  "herramientas": {
    "base_documental": [
      "ver_documentos",
      "cargar_documentos",
      "descargar_documentos"
    ],
    "enlaces": [
      "ver_enlaces",
      "cargar_enlaces"
    ],
    "calculadoras": []
  },
  "ayuda": [
    "soporte_tecnico",
    "acerca_de"
  ],
  "registros": [
    "registro_pai",
    "plan_parto",
    "gestionar_citologia"
  ],
  "analitica": [
    "reportes",
    "indicadores",
    "indicador_gubernamental"
  ]
};

const expanded = expandTree(PERMISSIONS_TREE);

export const PATHS = process.env.NODE_ENV === 'development'
  ? new Proxy(expanded, {
      get(target, prop) {
        if (typeof prop === 'string' && !(prop in target)) {
          console.error(`[Guard Rail] ❌ El permiso '${prop}' NO existe en PERMISSIONS_TREE. Revisa su escritura o actualiza la BD y corre 'npm run sync-perms'.`);
        }
        return target[prop];
      }
    })
  : expanded;
